"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function NewGmail24Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("g", { clipPath: "url(#clip0_7730_33677)" },
            react_1.default.createElement("path", { d: "M1.63636 21.0001H5.45455V11.7274L0 7.63647V19.3637C0 20.2692 0.733636 21.0001 1.63636 21.0001Z", fill: "#4285F4" }),
            react_1.default.createElement("path", { d: "M18.5449 20.9999H22.3631C23.2686 20.9999 23.9995 20.2662 23.9995 19.3635V7.63623L18.5449 11.7271", fill: "#34A853" }),
            react_1.default.createElement("path", { d: "M18.5449 4.63637V11.7273L23.9995 7.63637V5.45455C23.9995 3.43091 21.6895 2.27728 20.0722 3.49091", fill: "#FBBC04" }),
            react_1.default.createElement("path", { d: "M5.45508 11.7271V4.63623L12.0005 9.54532L18.546 4.63623V11.7271L12.0005 16.6362", fill: "#EA4335" }),
            react_1.default.createElement("path", { d: "M0 5.45455V7.63637L5.45455 11.7273V4.63637L3.92727 3.49091C2.30727 2.27728 0 3.43091 0 5.45455Z", fill: "#C5221F" })),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("clipPath", { id: "clip0_7730_33677" },
                react_1.default.createElement("rect", { width: 24, height: 18, fill: "white", transform: "translate(0 3)" }))));
}
function NewGmail24(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(NewGmail24Svg, Object.assign({}, svgProps)));
}
exports.default = NewGmail24;
//# sourceMappingURL=NewGmail24.js.map